import { getBenefitsFormDocumentsList } from "src/app/core/store/benefits/benefits.actions";
import { loadBenefitsFormDocument } from "./../../../../core/store/benefits/benefits.actions";
import { downloadFile } from "src/app/helpers/utils";
import { Component, OnInit, Input, signal, computed } from "@angular/core";
import { Store } from "@ngrx/store";
import { State } from "../../../../core/store";
import { BaseComponent } from "src/app/core/abstracts/baseComponent";
import { Actions, ofType } from "@ngrx/effects";
import { tap } from "rxjs";
import { AlertService } from "src/app/shared/services/alert.service";
import { Router, ActivatedRoute } from "@angular/router";
import { BenefitPlanFormDocumentsEnrollmentModel } from "src/app/models/benefitsModels";

@Component({
    selector: "app-list-my-enrollmentformdocs",
    templateUrl: "./list-my-enrollmentformdocs.component.html",
    styleUrls: ["./list-my-enrollmentformdocs.component.scss"],
    standalone: false
})
export class ListMyEnrollmentFormDocsComponent
  extends BaseComponent
  implements OnInit
{
  enrollmentFormDocs: BenefitPlanFormDocumentsEnrollmentModel[];
  loadingEnrollmentFormDocsList = false;
  hasNotSignedDoc = false;
  @Input() managedUserId;
  hasAnyDoc;
  notSignedDocs;

  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });

  constructor(
    private actions$: Actions,
    private alertService: AlertService,
    private store: Store<State>,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit() {
    if (this.route.snapshot.params.userId) {
      this.managedUserId = this.route.snapshot.params.userId;
    }
    this.subs.push(
      this.store
        .select((s) => s.benefitsState.docsListBenefit)
        .subscribe((enrollmentFormDocs) => {
          this.enrollmentFormDocs = enrollmentFormDocs;
          if(enrollmentFormDocs != null)
            this.totalRecords.set(enrollmentFormDocs.length);
          if (enrollmentFormDocs) {
            this.hasNotSignedDoc = enrollmentFormDocs.some(
              (doc) => !doc.signedDate,
            );
          }
        }),

      this.store
        .select((s) => s.benefitsState)
        .subscribe((benefitsState) => {
          this.loadingEnrollmentFormDocsList =
            benefitsState.loadingListBenefit || benefitsState.loadingDocBenefit;
        }),

      this.store
        .select((s) => s.benefitsState.docsListBenefit)
        .subscribe((enrollmentFormDocs) => {
          if (enrollmentFormDocs) {
            this.hasAnyDoc = enrollmentFormDocs.length > 0;
            this.notSignedDocs = enrollmentFormDocs.filter(
              (doc) => !doc.signedDate,
            ).length;
          }
        }),
    );

    this.store.dispatch(
      getBenefitsFormDocumentsList({ userId: this.managedUserId, enrollmentSetId: Number(this.route.snapshot.queryParamMap.get('enrollmentSetId')) || undefined }),
    );
  }

  sign(enrollmentFormDoc: BenefitPlanFormDocumentsEnrollmentModel) {
    this.router.navigate(["../sign/" + enrollmentFormDoc.id], {
      relativeTo: this.route,
      queryParamsHandling: 'preserve',
    });
  }

  signAsHR(enrollmentFormDoc: BenefitPlanFormDocumentsEnrollmentModel) {
    this.router.navigate(["../sign/" + enrollmentFormDoc.id], {
      relativeTo: this.route,
    });
  }

  // fillInfo(onboardingDocsUser: BenefitPlanFormDocumentsEnrollmentModel) {
  //   this.router.navigate(['../fill-info/' + onboardingDocsUser.id], { relativeTo: this.route });
  // }

  // fillInfoHR(onboardingDocsUser: BenefitPlanFormDocumentsEnrollmentModel) {
  //   this.router.navigate(['../fill-info-hr/' + onboardingDocsUser.id], { relativeTo: this.route });
  // }

  viewDoc(enrollmentFormDoc: BenefitPlanFormDocumentsEnrollmentModel) {
    this.store.dispatch(
      loadBenefitsFormDocument({
        benefitPlanFormDocumentsEnrollmentID: enrollmentFormDoc.id,
      }),
    );
    const subDocBuffer = this.store
      .select((s) => s.benefitsState.docArrayBufferBenefit)
      .subscribe((docArrayBuffer) => {
        if (docArrayBuffer) {
          downloadFile(
            new Blob([docArrayBuffer], { type: "application/pdf" }),
            enrollmentFormDoc.benefitPlanFormDocument.fileName,
          );
          subDocBuffer.unsubscribe();
        }
      });
  }

  openEnrollment() {
    this.router.navigate(["benefits-enrollment/enrollment"]);
  }
}
